import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useOnce } from '../../../../hooks';
import debouncer from '../../../../modules/debouncer';
import type { IRootDispatch, RootState } from '../../../../store/models';
import { ABTestMenu, TestAssignment } from './ABTestMenu';

export const ABTestMenuContainer: React.FCWithChildren = () => {
  const {
    abTest: {
      forceAssignTest,
    },
  } = useDispatch<IRootDispatch>();
  const [assignments, setTestAssignments] = useState<Array<TestAssignment>>([]);
  const storedAssignments: Array<TestAssignment> = useSelector<RootState, Array<TestAssignment>>(
    state => Object.keys(state.abTest.assignments).filter(
      key => typeof state.abTest.assignments[key].allocationPercent === 'number',
    ).map((key: string): TestAssignment => ({
      ...state.abTest.assignments[key],
      name: key,
    })),
  );
  const debounce = debouncer(1000);

  const handleValueChange = (testName: string, newValue: number | boolean) => {
    debounce(() => {
      forceAssignTest({
        name: testName,
        allocation: newValue,
      });
    });
  };

  useOnce(() => {
    setTestAssignments(storedAssignments);
  }, storedAssignments);

  return (
    <ABTestMenu
      assignments={assignments}
      onValueChange={handleValueChange}
      onChoiceChange={handleValueChange}
    />
  );
};
